import { Component } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Counter from './Counter';
import { DATA } from './configs';
import { calculatePricePerInterval } from './utils';
import MessageCustom from '../../../components/MessageCustom';

class Products extends Component {
    constructor(props) {
        super(props);

        this.onChangeGoogleSearchAnalyticsDomains =
            this.onChangeGoogleSearchAnalyticsDomains.bind(this);
        this.onChangeAiTrackingDomains = this.onChangeAiTrackingDomains.bind(this);
        this.onToggleProducts = this.onToggleProducts.bind(this);
        this.onChangeAiTrackingBlur = this.onChangeAiTrackingBlur.bind(this);

        this.aiTrackingMinValue = props.isAiTemplate ? 20 : 100;
    }

    updateUrlsSearch(key, value) {
        this.url = new URL(window.location);

        if (Array.isArray(value)) {
            if (value?.length) {
                this.url.searchParams.set(key, value.join(','));
            } else {
                this.url.searchParams.delete(key);
            }
        } else {
            if (value === '') {
                this.url.searchParams.delete(key);
            } else {
                this.url.searchParams.set(key, value);
            }
        }
        history.pushState({}, '', this.url);
    }

    onChangeGoogleSearchAnalyticsDomains(value) {
        this.props.onChangeProducts('google_analytics_domains', value);
        this.updateUrlsSearch('google_analytics_domains', value);
    }

    onChangeAiTrackingDomains(value) {
        this.props.onChangeProducts('ai_tracking_prompts', value);
        this.updateUrlsSearch('ai_tracking_prompts', value);
    }

    onToggleProducts(key) {
        const products = { ...this.props.products };
        products[key] = !products[key];
        this.props.onChangeProducts(key, products[key], true);

        const productsState = {
            google_discover_analytics: products.google_discover_analytics,
            google_search_analytics: products.google_search_analytics,
            ai_tracking: products.ai_tracking,
            commerce: products.commerce,
            [key]: products[key],
        };

        const values = [];

        for (key in productsState) {
            if (productsState[key]) {
                values.push(key);
            }
        }
        this.updateUrlsSearch('products', values.length ? values : null);
    }

    onChangeAiTrackingBlur() {
        const value = this.props.products.ai_tracking_prompts
            ? Number(this.props.products.ai_tracking_prompts)
            : 0;

        if (value < this.aiTrackingMinValue) {
            return this.props.onChangeProducts('ai_tracking_prompts', this.aiTrackingMinValue);
        }
        if (value % 10 !== 0) {
            const roundedValue = Math.ceil(value / 10) * 10;
            this.props.onChangeProducts('ai_tracking_prompts', roundedValue);
        }
    }

    createTooltipContent(product) {
        const items = DATA.find((item) => item.category === product)?.features?.slice(0, 6) ?? [];
        let icon = null;
        let header = null;
        let description = null;
        switch (product) {
            case 'google_discover_analytics': {
                icon = '/static/img/google_discover.svg';
                header = 'Google Discover';
                description =
                    'Turn Google Discover into a repeatable growth engine by analyzing your historical data to double down on winning categories, entities, and authors.';
                break;
            }
            case 'search_analytics': {
                icon = '/static/img/google-icon.png';
                header = 'Google Search';
                description =
                    'Unify your Google Search Console reports, automatically cluster keywords, and flag evergreen content decay to protect and scale your search traffic.';
                break;
            }
            case 'ai_analytics': {
                icon = '/static/img/ai_icon.svg';
                header = 'AI Tracking';
                description =
                    'Defend your brand’s presence as search shifts to AI by tracking mentions and mapping specific entities to prompts across all major AI platforms.';
                break;
            }
            case 'commerce': {
                icon = '/static/img/google_icon_2.svg';
                header = 'Commerce';
                description =
                    'Tie your SEO directly to monetization by mapping market share, identifying profitable content gaps, and highlighting high-CPC affiliate opportunities.';
                break;
            }
        }
        return (
            <Tooltip id={`info-tooltip-${product}`} place="bottom" className="custom-tooltip">
                <div className="custom-tooltip-content">
                    <strong>{header}</strong>
                    <div className="custom-tooltip-content-description">{description}</div>
                    <div className="custom-tooltip-content-products">
                        {items.map((item) => (
                            <div key={item.title} className="custom-tooltip-content-products-item">
                                <div className="custom-tooltip-content-products-item-img">
                                    <img src={icon} />
                                </div>
                                <div className="custom-tooltip-content-products-item-content">
                                    <div className="header">{item.title}</div>
                                    <div className="description">{item.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Tooltip>
        );
    }

    render() {
        const { billingInfo } = this.props;

        const discoverAnalyticsStartAt =
            calculatePricePerInterval(
                billingInfo.discoverAnalytics?.prices,
                this.props.products.google_analytics_domains || 1,
                this.props.interval,
                true,
            )?.price || 0;
        const searchAnalyticsStartAt =
            calculatePricePerInterval(
                billingInfo.searchAnalytics?.prices,
                this.props.products.google_analytics_domains || 1,
                this.props.interval,
                true,
            )?.price || 0;
        const aiTrackingStartAt =
            calculatePricePerInterval(
                billingInfo.ai_tracking?.prices,
                this.props.products.ai_tracking_prompts || 1,
                this.props.interval,
                true,
            )?.price || 0;
        const commerceStartAt =
            calculatePricePerInterval(billingInfo.commerce?.prices, 1, this.props.interval, true)
                ?.price || 0;

        return (
            <>
                <div className="custom-registration-body-step">
                    <div className="custom-registration-body-step-header">
                        <span>1</span> Choose your products
                    </div>

                    <div className="custom-registration-body-step-body">
                        <div
                            className={`custom-registration-products ${
                                !this.props.isEdit && this.props.isFreeAiTemplate ? 'grid-1' : ''
                            }`}
                        >
                            {(!this.props.isFreeAiTemplate || this.props.isEdit) && (
                                <div
                                    className={`custom-registration-products-item ${
                                        this.props.products.google_discover_analytics
                                            ? 'active'
                                            : ''
                                    }
                                ${
                                    this.props.defaultData?.discoverAnalytics &&
                                    !this.props.products.google_discover_analytics
                                        ? 'error'
                                        : ''
                                }
                                `}
                                >
                                    <div className="custom-registration-products-item-header">
                                        <div className="d-flex gap-8 align-items-center">
                                            <img
                                                className="custom-registration-products-item-icon"
                                                src="/static/img/google_discover.svg"
                                            />
                                            <div>
                                                Discover Analytics{' '}
                                                {this.props.defaultData?.discoverAnalytics && '**'}
                                            </div>
                                        </div>
                                        <div
                                            className="ml-auto switcher-container"
                                            style={
                                                this.props.isFreeAiTemplate ? { opacity: 0.5 } : {}
                                            }
                                        >
                                            <span
                                                className={`switch-button without-text ${
                                                    this.props.products.google_discover_analytics
                                                        ? 'active'
                                                        : 'not-active'
                                                }`}
                                                onClick={() =>
                                                    !this.props.isFreeAiTemplate
                                                        ? this.onToggleProducts(
                                                              'google_discover_analytics',
                                                          )
                                                        : null
                                                }
                                            >
                                                <span className="switch-circle" />
                                            </span>
                                        </div>
                                    </div>
                                    {!this.props.products.google_discover_analytics &&
                                    this.props.defaultData?.discoverAnalytics ? (
                                        <div className="custom-registration-products-item-description top error">
                                            Will be removed
                                        </div>
                                    ) : this.props.defaultData &&
                                      this.props.products.google_discover_analytics &&
                                      !this.props.defaultData?.discoverAnalytics ? (
                                        <div className="custom-registration-products-item-description top new">
                                            Will be added
                                        </div>
                                    ) : (
                                        this.props.defaultData?.discoverAnalytics && (
                                            <div className="d-flex align-items-center gap-4">
                                                <div className="custom-registration-products-item-description top included">
                                                    Included
                                                </div>
                                                {this.props.products.google_analytics_domains -
                                                    this.props.defaultData?.discoverAnalytics
                                                        ?.quantity >
                                                    0 && (
                                                    <div className="custom-registration-products-item-description-small">{`+ ${
                                                        this.props.products
                                                            .google_analytics_domains -
                                                        this.props.defaultData?.discoverAnalytics
                                                            ?.quantity
                                                    } domain(s) added`}</div>
                                                )}
                                            </div>
                                        )
                                    )}
                                    <div className="custom-registration-products-item-description">
                                        Turn Google Discover into a repeatable growth engine by
                                        analyzing your historical data to double down on winning
                                        categories, entities, and authors.
                                    </div>
                                    <div className="custom-registration-products-item-bottom">
                                        <div className="custom-registration-products-item-count">
                                            <Counter
                                                value={this.props.products.google_analytics_domains}
                                                onChange={this.onChangeGoogleSearchAnalyticsDomains}
                                                disabled={this.props.isFreeAiTemplate}
                                            />
                                            Domains
                                        </div>
                                        <div className="d-flex gap-8 align-items-center justify-content-between w-100">
                                            <div>
                                                Starts at: ${discoverAnalyticsStartAt} / Domain
                                            </div>
                                            <div
                                                className="txt-helper-tooltip"
                                                data-tooltip-id="info-tooltip-google_discover_analytics"
                                            >
                                                See what's included
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {(!this.props.isFreeAiTemplate || this.props.isEdit) && (
                                <div
                                    className={`custom-registration-products-item ${
                                        this.props.products.google_search_analytics ? 'active' : ''
                                    }
                                ${
                                    this.props.defaultData?.searchAnalytics &&
                                    !this.props.products.google_search_analytics
                                        ? 'error'
                                        : ''
                                }
                                `}
                                >
                                    <div className="custom-registration-products-item-header">
                                        <div className="d-flex gap-8 align-items-center">
                                            <img
                                                className="custom-registration-products-item-icon"
                                                src="/static/img/google-icon.png"
                                            />
                                            <div>
                                                Search Analytics{' '}
                                                {this.props.defaultData?.searchAnalytics && '**'}
                                            </div>
                                        </div>
                                        <div
                                            className="ml-auto switcher-container"
                                            style={
                                                this.props.isFreeAiTemplate ? { opacity: 0.5 } : {}
                                            }
                                        >
                                            <span
                                                className={`switch-button without-text mr-10 ${
                                                    this.props.products.google_search_analytics
                                                        ? 'active'
                                                        : 'not-active'
                                                }`}
                                                onClick={() =>
                                                    !this.props.isFreeAiTemplate
                                                        ? this.onToggleProducts(
                                                              'google_search_analytics',
                                                          )
                                                        : null
                                                }
                                            >
                                                <span className="switch-circle" />
                                            </span>
                                        </div>
                                    </div>

                                    {!this.props.products.google_search_analytics &&
                                    this.props.defaultData?.searchAnalytics ? (
                                        <div className="custom-registration-products-item-description top error">
                                            Will be removed
                                        </div>
                                    ) : this.props.defaultData &&
                                      this.props.products.google_search_analytics &&
                                      !this.props.defaultData?.searchAnalytics ? (
                                        <div className="custom-registration-products-item-description top new">
                                            Will be added
                                        </div>
                                    ) : (
                                        this.props.defaultData?.searchAnalytics && (
                                            <div className="d-flex align-items-center gap-4">
                                                <div className="custom-registration-products-item-description top included">
                                                    Included
                                                </div>
                                                {this.props.products.google_analytics_domains -
                                                    this.props.defaultData?.searchAnalytics
                                                        ?.quantity >
                                                    0 && (
                                                    <div className="custom-registration-products-item-description-small">{`+ ${
                                                        this.props.products
                                                            .google_analytics_domains -
                                                        this.props.defaultData?.searchAnalytics
                                                            ?.quantity
                                                    } domain(s) added`}</div>
                                                )}
                                            </div>
                                        )
                                    )}
                                    <div className="custom-registration-products-item-description">
                                        Unify your Google Search Console reports, automatically
                                        cluster keywords, and flag evergreen content decay to
                                        protect and scale your search traffic.
                                    </div>
                                    <div className="custom-registration-products-item-bottom">
                                        <div className="custom-registration-products-item-count">
                                            <Counter
                                                value={this.props.products.google_analytics_domains}
                                                onChange={this.onChangeGoogleSearchAnalyticsDomains}
                                                disabled={this.props.isFreeAiTemplate}
                                            />
                                            Domains
                                        </div>
                                        <div className="d-flex gap-8 align-items-center justify-content-between w-100">
                                            <div>Starts at: ${searchAnalyticsStartAt} / Domain</div>
                                            <div
                                                className="txt-helper-tooltip"
                                                data-tooltip-id="info-tooltip-search_analytics"
                                            >
                                                See what's included
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div
                                className={`custom-registration-products-item ${
                                    this.props.products.ai_tracking ? 'active' : ''
                                }
                                ${
                                    this.props.defaultData?.ai_tracking &&
                                    !this.props.products.ai_tracking
                                        ? 'error'
                                        : ''
                                }
                                `}
                            >
                                <div className="custom-registration-products-item-header">
                                    <div className="d-flex gap-8 align-items-center">
                                        <img
                                            className="custom-registration-products-item-icon"
                                            src="/static/img/ai_icon.svg"
                                        />
                                        <div>
                                            AI Tracking{' '}
                                            {this.props.defaultData?.ai_tracking && '**'}
                                        </div>
                                    </div>
                                    <div
                                        className="ml-auto switcher-container"
                                        style={this.props.isFreeAiTemplate ? { opacity: 0.5 } : {}}
                                    >
                                        <span
                                            className={`switch-button without-text mr-10 ${
                                                this.props.products.ai_tracking
                                                    ? 'active'
                                                    : 'not-active'
                                            }`}
                                            onClick={() =>
                                                !this.props.isFreeAiTemplate
                                                    ? this.onToggleProducts('ai_tracking')
                                                    : null
                                            }
                                        >
                                            <span className="switch-circle" />
                                        </span>
                                    </div>
                                </div>
                                {!this.props.products.ai_tracking &&
                                this.props.defaultData?.ai_tracking ? (
                                    <div className="custom-registration-products-item-description top error">
                                        Will be removed
                                    </div>
                                ) : this.props.defaultData &&
                                  this.props.products.ai_tracking &&
                                  !this.props.defaultData?.ai_tracking ? (
                                    <div className="custom-registration-products-item-description top new">
                                        Will be added
                                    </div>
                                ) : (
                                    this.props.defaultData?.ai_tracking && (
                                        <div className="d-flex align-items-center gap-4">
                                            <div className="custom-registration-products-item-description top included">
                                                Included
                                            </div>
                                            {this.props.products.ai_tracking_prompts -
                                                this.props.defaultData?.ai_tracking?.quantity >
                                                0 && (
                                                <div className="custom-registration-products-item-description-small">{`+ ${
                                                    this.props.products.ai_tracking_prompts -
                                                    this.props.defaultData?.ai_tracking?.quantity
                                                } prompts(s) added`}</div>
                                            )}
                                        </div>
                                    )
                                )}
                                <div className="custom-registration-products-item-description">
                                    Defend your brand’s presence as search shifts to AI by tracking
                                    mentions and mapping specific entities to prompts across all
                                    major AI platforms.
                                </div>
                                <div className="custom-registration-products-item-bottom">
                                    <div className="custom-registration-products-item-count">
                                        <Counter
                                            value={this.props.products.ai_tracking_prompts}
                                            onChange={this.onChangeAiTrackingDomains}
                                            inputStyle={{ width: '60px' }}
                                            step={10}
                                            onBlur={this.onChangeAiTrackingBlur}
                                            minValue={this.aiTrackingMinValue}
                                            maxValue={100000}
                                        />
                                        <div>
                                            Prompt Tracking Credits
                                            <div className="custom-registration-products-item-count-message">
                                                Minimum {this.aiTrackingMinValue}, must be multiple
                                                of 10
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.isFreeAiTemplate && (
                                        <div className="custom-registration-products-item-trial-badge">
                                            <i className="icon-check-icon" />
                                            50 AI Tracking credits included during trial
                                        </div>
                                    )}
                                    <div className="d-flex gap-8 align-items-center justify-content-between w-100">
                                        {this.props.isFreeAiTemplate ? (
                                            <div />
                                        ) : (
                                            <div>
                                                Starts at: ${aiTrackingStartAt?.toFixed(2)} / Prompt
                                            </div>
                                        )}
                                        <div
                                            className="txt-helper-tooltip"
                                            data-tooltip-id="info-tooltip-ai_analytics"
                                        >
                                            See what's included
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!this.props.isFreeAiTemplate && (
                                <div
                                    className={`custom-registration-products-item ${
                                        this.props.products.commerce ? 'active' : ''
                                    }
                                ${
                                    this.props.defaultData?.commerce &&
                                    !this.props.products.commerce
                                        ? 'error'
                                        : ''
                                }
                                `}
                                >
                                    <div className="custom-registration-products-item-header">
                                        <div className="d-flex gap-8 align-items-center">
                                            <img
                                                className="custom-registration-products-item-icon"
                                                src="/static/img/google_icon_2.svg"
                                            />
                                            <div>
                                                Commerce {this.props.defaultData?.commerce && '**'}
                                            </div>
                                        </div>
                                        <div className="ml-auto switcher-container">
                                            <span
                                                className={`switch-button without-text mr-10 ${
                                                    this.props.products.commerce
                                                        ? 'active'
                                                        : 'not-active'
                                                }`}
                                                onClick={() => this.onToggleProducts('commerce')}
                                            >
                                                <span className="switch-circle" />
                                            </span>
                                        </div>
                                    </div>

                                    {!this.props.products.commerce &&
                                    this.props.defaultData?.commerce ? (
                                        <div className="custom-registration-products-item-description top error">
                                            Will be removed
                                        </div>
                                    ) : this.props.defaultData &&
                                      this.props.products.commerce &&
                                      !this.props.defaultData?.commerce ? (
                                        <div className="custom-registration-products-item-description top new">
                                            Will be added
                                        </div>
                                    ) : (
                                        this.props.defaultData?.commerce && (
                                            <div className="custom-registration-products-item-description top included">
                                                Included
                                            </div>
                                        )
                                    )}
                                    <div className="custom-registration-products-item-description">
                                        Tie your SEO directly to monetization by mapping market
                                        share, identifying profitable content gaps, and highlighting
                                        high-CPC affiliate opportunities.
                                    </div>
                                    <div className="custom-registration-products-item-bottom">
                                        <div className="d-flex gap-8 align-items-center justify-content-between w-100">
                                            <div>Starts at: ${commerceStartAt}</div>
                                            <div
                                                className="txt-helper-tooltip"
                                                data-tooltip-id="info-tooltip-commerce"
                                            >
                                                See what's included
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {this.props.isEdit && (
                        <div className="custom-registration-products-note">
                            <MessageCustom
                                message={
                                    '** Included in your current plan. You will not be charged extra for this product. If you increase the quantity of an included product, you will be charged only for the difference. If you add a new product, it will be added to your invoice.'
                                }
                                isHeaderSeperated
                                hideCloseBtn
                                message_type="alert-info"
                            />
                        </div>
                    )}
                </div>
                {this.createTooltipContent('ai_analytics')}
                {this.createTooltipContent('google_discover_analytics')}
                {this.createTooltipContent('search_analytics')}
                {this.createTooltipContent('commerce')}
            </>
        );
    }
}

export default Products;
